import { render } from "./RadioInput.vue?vue&type=template&id=af26a208"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__